module.exports = __webpack_public_path__ + "static/media/Alerts.a1603c32.PNG";